export const HAZARDS = 'HAZARDS';
export const LONGITS = 'LONGITS';
export const DISTRIBUTION = 'DISTRIBUTION';
